import { SortOptions as LegacySortOptions } from './sort-options-model';
import { KnownAttributes } from 'domain/experiment/attribute';

export function getStandardSortingOptions(): LegacySortOptions {
  return {
    sortBy: [KnownAttributes.CreationTime],
    sortDirection: ['descending'],
    sortFieldType: ['datetime'],
    sortFieldAggregationMode: ['auto'],
  };
}
